import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMinimize315: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMinimize315"><Path fillRule="evenodd" clipRule="evenodd" d="M2.33594 3.74991L7.58594 8.99991H3.00015V10.9999H11.0002V2.99991H9.00015V7.58569L3.75015 2.33569L2.33594 3.74991ZM21.0002 12.9999H13.0002V20.9999H15.0002V16.4141L20.2502 21.6641L21.6644 20.2499L16.4144 14.9999H21.0002V12.9999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMinimize315;
